export interface GroupedSelectOptionType {
    label: string;
    value: string;
    options?: GroupedSelectOptionType[];
}

const PRODUCT_SUPPLIERS_REASON: GroupedSelectOptionType = {
    label: 'See the latest products to use in my Project',
    value: 'Product Suppliers',
};

export const HOMEOWNER_REASON_FOR_ATTENDING: GroupedSelectOptionType[] = [
    { label: 'Meet Architects', value: 'Meet Architects' },
    { label: 'Meet Builders', value: 'Meet Builders' },
    { label: 'Meet Interior Designers', value: 'Meet Interior Designers' },
    PRODUCT_SUPPLIERS_REASON,
    { label: 'Tips from the Panel', value: 'Tips from the Panel' },
    { label: 'Other', value: 'Other' },
];

export const INTERESTED_PRODUCTS: GroupedSelectOptionType[] = [
    { label: 'Bathroom', value: 'Bathroom' },
    { label: 'Building', value: 'Building' },
    { label: 'Cladding & Facades', value: 'Cladding & facades' },
    { label: 'Roofing', value: 'Roofing' },
    { label: 'Windows & Doors', value: 'Windows & doors' },
    { label: 'Finishes', value: 'Finishes' },
    { label: 'Flooring', value: 'Flooring' },
    { label: 'Tiles & Stones', value: 'Tiles & stones' },
    { label: 'Furniture', value: 'Furniture' },
    {
        label: 'Heating, Cooling & Ventilation',
        value: 'Heating, cooling & ventilation',
    },
    {
        label: 'Home Living / Fitness Equipment',
        value: 'Home living / fitness equipment',
    },
    { label: 'Electronics & Automation', value: 'Electronics & automation' },
    { label: 'Kitchen & Laundry', value: 'Kitchen & laundry' },
    { label: 'Lighting', value: 'Lighting' },
    { label: 'Outdoor & Landscaping', value: 'Outdoor & landscaping' },
];

export const HEAR_ABOUT_MGE: GroupedSelectOptionType[] = [
    { label: 'ArchiPro website', value: 'ArchiPro website' },
    { label: 'ArchiPro Email', value: 'ArchiPro Email' },
    { label: 'Facebook', value: 'Facebook' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Google', value: 'Google' },
    { label: 'Pinterest', value: 'Pinterest' },
    { label: 'Referral from a friend', value: 'Referral from a friend' },
    {
        label: 'Referral from a professional',
        value: 'Referral from a professional',
    },
    { label: 'Previously attended', value: 'Previously attended' },
    { label: 'Other', value: 'Other' },
];

export const COMPANY_TYPE: GroupedSelectOptionType[] = [
    { label: 'Architect', value: 'Architect' },
    { label: 'Architectural Designer', value: 'Architectural Designer' },
    { label: 'Builder', value: 'Builder' },
    {
        label: 'Construction Services',
        value: 'Construction Services',
    },
    { label: 'Interior Designer', value: 'Interior Designer' },
    { label: 'Product Supplier', value: 'Product Supplier' },
    {
        label: 'Landscape Architect / Designer',
        value: 'Landscape Architect/Designer',
    },
    {
        label: 'Trade Services',
        value: 'Trade Services',
    },
    { label: 'Other', value: 'Other' },
];
